import { KapiNotification } from "@opstel/query/models/kapiNotification";
import { create } from "zustand";

interface PendingInstanceData {
  notifications: KapiNotification[];
  instanceId: string;
}

export const usePendingInstanceData = create<{
  data?: PendingInstanceData;
  setData: (data: PendingInstanceData) => void;
  clearData: () => void;
}>((set) => ({
  setData: (data: PendingInstanceData) => set({ data }),
  clearData: () => set({ data: undefined }),
}));
